import { Card, CardBody } from '@ds';
import { ResourceAvatar } from '@ui';
import {
  CaseClinicalSpecialistResource,
  CaseOCSConsoleResource,
  CaseResource,
  CaseRetrievalSurgeonResource,
} from '@/api/apis/case';
import { CaseLogisticsDeviceInfo } from './CaseLogisticsDeviceInfo';
import { CaseLogisticsEmployeeInfo } from './CaseLogisticsEmployeeInfo';

type FullResourcesListProps = {
  deviceList: CaseResource<CaseOCSConsoleResource>[];
  csList: CaseResource<CaseClinicalSpecialistResource>[];
  rsList: CaseResource<CaseRetrievalSurgeonResource>[];
  isScs: boolean;
};

export const FullResourcesList = ({ csList, rsList, deviceList, isScs }: FullResourcesListProps) => {
  return (
    <div className="flex flex-col gap-3 items-stretch">
      <span className="text-m-sb text-base-5">Clinical Resources</span>
      {deviceList.map((r) => (
        <CaseLogisticsDeviceInfo key={r.resourceId} device={r} />
      ))}
      {csList.map((r) => (
        <CaseLogisticsEmployeeInfo key={r.resourceId} employee={r} subTitle="Clinical Specialist" />
      ))}
      {rsList.map((r) => (
        <CaseLogisticsEmployeeInfo key={r.resourceId} employee={r} subTitle="Retrieval Surgeon" />
      ))}
      {isScs && (
        <Card className="shadow-none rounded-2xl bg-base-60">
          <CardBody>
            <div className="flex gap-2">
              <ResourceAvatar key="SCS" id="SCS" type="scs" size="md" radius="md" />
              <span className="text-m-m text-base-5">The static cold storage with the organ on this leg</span>
            </div>
          </CardBody>
        </Card>
      )}
    </div>
  );
};
